import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.X_LAYER]

export const SUPPORT_FARMS = [ChainId.BSC, ChainId.BSC_TESTNET, ChainId.ETHEREUM, ChainId.GOERLI, ChainId.X1_TESTNET]

export const SUPPORT_ZAP = [ChainId.BSC, ChainId.BSC_TESTNET]

export const SUPPORT_CAKE_STAKING = [ChainId.BASE_SEPOLIA]
